<template>
  <div class="wrap">
    <!-- 顶部Banner -->
    <div class="bannerimg">
      <img
        class="beijing"
        src="@/assets/image/lunbo/beijing3.png"
        alt=""
        style="height: 480px"
      />
      <div class="biaotowenzi">
        <h2>科技引领、创新驱动、客户至上</h2>
        <br />
        <p>
          广州鹏海专注于通信网络的集成、应用与服务，致力于为客户提供定制化的解决方案
        </p>
      </div>
    </div>

    <!-- 导航菜单 -->
    <Nav :nav-items="navItems" @nav-change="handleNavChange" />

    <!-- 动态内容区域 -->
    <transition name="fade" mode="out-in">
      <div
        v-if="activeTab == navItem.id"
        :key="navItem.id"
        class="anquan"
        v-for="navItem in navItems"
      >
        <!-- 安全内容 -->
        <div class="wenzih1">{{ navItem.title }}</div>
        <div class="wenzi2">
          <span v-html="navItem.content"></span>
          <br /><br />
          <hr />
          <br /><br />
          <p>{{ navItem.title }}业务流程：</p>
        </div>
        <br /><br />
        <img :src="navItem.imageUrl" alt="" class="liuchengtu" />
        <br /><br />
      </div>
    </transition>

    <!-- 客户案例（共用部分） -->
    <!-- <div class="kuhu">
      <div class="fontanli">
        客户案例<br><br>
        <div class="imgtwo">
          <img src="@/assets/other/lanyueliang.png" alt="">
          <img src="@/assets/other/jianguanhui.png" alt="">
        </div>
      </div>
      <div class="kehuanli">
        <img src="@/assets/other/kehuanlibeijing.png" style="height:auto; object-fit: contain;" />
      </div>
    </div> -->

    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
import Nav from "../../components/Nav/Nav.vue";
import { getCaseList } from "@/api/api.js";

export default {
  name: "cooperation",
  components: {
    Nav,
  },
  data() {
    return {
      // activeTab: "blueMoon",
      activeTab: this.$route.params.tab || "blueMoon",
      navItems: [],
    };
  },
  created() {
    this.getList(); // 初始化加载按钮数据
  },
  watch: {
    $route(to) {
      // 更可靠的路由变化监听
      this.activeTab = to.params.tab || "blueMoon";
    },
  },
  methods: {
    // handleNavChange(item) {
    //   this.activeTab = item.id;
    // }
    handleNavChange(item) {
      this.activeTab = item.id;
      // 使用相同的跳转方式保持一致性
      this.$router.push({
        name: "cooperation",
        params: {
          tab: item.id,
        },
      });
    },
    async getList() {
      const response = await getCaseList();
      this.navItems = response.rows;

      if (!this.$route.params.tab && this.navItems.length > 0) {
        this.activeTab = this.navItems[0].id;
        // 同时更新路由
        this.$router.push({
          name: "cooperation",
          params: {
            tab: this.activeTab,
          },
        });
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;

  /* 添加切换动画 */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  /* 原有样式保持不变 */
  .imgtwo {
    margin-left: -300px;
  }

  .kehuanli {
    width: 100%;
  }

  .fontanli img {
    display: block;
    float: left;
    margin-right: 10px;
    object-fit: contain;
    width: 42%;
    height: 42%;
  }

  .fontanli {
    margin-bottom: -50px;
    max-width: 1440px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    vertical-align: top;
    transform: translateY(300px);
  }

  .kuhu {
    width: 100%;
    display: flex;
    height: auto;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 auto;
  }

  .liuchengtu {
    object-fit: contain;
    align-items: center;
    width: 71%;
  }

  .wenzi2 p {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 28.8px;
    color: rgba(47, 49, 51, 1);
    text-align: left;
    vertical-align: top;
  }

  .wenzi2 {
    margin-top: 50px;
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 32px;
    color: rgba(103, 103, 103, 1);
    text-align: center;
    vertical-align: top;
  }

  .wenzih1 {
    margin-top: 30px;
    font-size: 35px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 55.5px;
    color: rgba(46, 49, 51, 1);
    text-align: center;
    vertical-align: top;
  }

  .anquan {
    width: 1440px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 auto;
  }

  .bannerimg {
    position: relative;
  }

  .biaotowenzi {
    position: absolute;
    top: 50%;
    /* 垂直居中 */
    left: 12%;
    /* 水平靠左（可根据需求调整百分比） */
    transform: translateY(-50%);
    /* 精确垂直居中 */
    color: white;
    /* 文字颜色 */
    text-align: left;
    /* 文字左对齐 */
    max-width: 80%;
    /* 防止文字过长 */
    padding: 20px;
    /* 文字内边距 */
    z-index: 2;
    /* 确保文字在图片上方 */

    h2 {
      font-size: 35px;
      font-weight: 500;
      letter-spacing: 0px;
      color: rgba(255, 255, 255, 1);
      text-align: left;
      vertical-align: top;
    }

    p {
      font-size: 22px;
      font-weight: 500;
      letter-spacing: 0px;
      color: rgba(255, 255, 255, 1);
      text-align: left;
      vertical-align: top;
    }
  }
}
</style>

<style lang="scss">
.workspace-footer.footerbox {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/cooperation.vue